// export const API_BASE = 'http://10.0.5.144:3006/api'
// export const META_API_BASE = 'http://10.0.5.144:3001/api'
// export const API_BASE = 'http://43.201.141.252:3006/api'
// export const META_API_BASE = 'http://43.201.141.252:3001/api'
export const API_BASE = 'https://pa-s3access.sciencejournals.ru/api'
export const META_API_BASE = 'https://pa-metaapi.sciencejournals.ru/api'

// test changes 45



// WEBPACK FOOTER //
// ./src/config.js